export const API_ENDPOINTS = {
  VISITOR: {
    CREATE: '/api/v1/visitor/create',
    GET_INVISIBLE: (confirmCode: string) => `/api/v1/visitor/invisible/${confirmCode}`,
  },
  INFO: {
    LINE: (confirmCode: string) => `/api/v1/visitor/${confirmCode}`,
  },
};
